import { createFileRoute } from "@tanstack/react-router";
import PDFToSheetGuide from "@/pages/resources/PDFToSheetGuide";

export const Route = createFileRoute("/learn/pdf-to-sheet")({
  head: () => ({
    meta: [
        {
            "title": "How to Turn a Course PDF into a Revision Sheet: Tutorial | System Atlas"
        },
        {
            "name": "description",
            "content": "Step-by-step tutorial to transform your course PDFs into structured, study-ready revision sheets using AI. Upload, generate, refine, and study smarter."
        },
        {
            "property": "og:title",
            "content": "How to Turn a Course PDF into a Revision Sheet: Tutorial | System Atlas"
        },
        {
            "property": "og:description",
            "content": "Step-by-step tutorial to transform your course PDFs into structured, study-ready revision sheets using AI. Upload, generate, refine, and study smarter."
        },
        {
            "property": "og:type",
            "content": "article"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/learn/pdf-to-sheet"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "How to Turn a Course PDF into a Revision Sheet: Tutorial | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "Step-by-step tutorial to transform your course PDFs into structured, study-ready revision sheets using AI. Upload, generate, refine, and study smarter."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/learn/pdf-to-sheet"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn/pdf-to-sheet"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn/pdf-to-sheet"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn/pdf-to-sheet"
        }
    ],
  }),
  component: PDFToSheetGuide,
});
